import "./Footer.scss";

function Footer(props) {
    return <footer className="footer">
        Created By Mira Makadia
    </footer>
}

export default Footer;